import { CellListElement } from 'commons/components';
import { TooltipedCustomFieldCell } from 'commons/components/table/components/TooltipedCustomFieldCell.component';
import { TooltipedMoreIndicatorStyled } from 'commons/components/table/custom-table.style';

interface TrackedEventsCellProps {
    events: string[];
}

export const TrackedEventsCell: React.FC<TrackedEventsCellProps> = ({ events }) => {
    if (!events || events.length === 0) {
        return <>-</>;
    }

    if (events.length === 1) {
        return <TooltipedCustomFieldCell value={events[0]} />;
    }

    return (
        <CellListElement>
            <TooltipedCustomFieldCell value={events[0]} />
            <CellListElement>
                <TooltipedMoreIndicatorStyled
                    value={`+${events.length - 1}`}
                    tooltipText={events.slice(1).join(', ')}
                    showTooltipAlways
                />
            </CellListElement>
        </CellListElement>
    );
};
